import dayJs, { Dayjs, OptionType } from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DateObject } from '../entities';
import { SECOND_IN_MS } from '../constants/time';

dayJs.extend(localizedFormat);
dayJs.extend(advancedFormat);
dayJs.extend(customParseFormat);

export const formatDate = (date: number | string | Date, format: string) => dayJs(date).format(format);

export const createDate = (
  date?: string | number | Date | Dayjs | null | undefined,
  format?: OptionType,
  locale?: string,
  strict?: boolean,
) => {
  return dayJs(date, format, locale, strict);
};

export const validateDate = (date: string): boolean => {
  return dayJs(date).isValid();
};

export const isBefore = (dateNow: number, dateToCompare: number) => {
  return dayJs(dateNow).isBefore(dayJs(dateToCompare));
};

export const convertSecToMs = (sec: number) => sec * SECOND_IN_MS;

export const convertNumericMonthToString = (month: number) => dayJs().month(month).format('MMM');

export const getCurrentYear = () => new Date().getFullYear();

export const isValidDate = (date: string | number | Date | Dayjs | null | undefined): date is Date =>
  dayJs(date).isValid();

export const isValidDateStrict = (date: string | number | Date | Dayjs | null | undefined): date is Date =>
  dayJs(date, 'YYYY-MM-DD', true).isValid();

export const isSameDay = (date1: string, date2: string) => dayJs(date1).isSame(date2, 'day');

export const isAfter = (date: string, dateToCompare: string) => dayJs(date).isAfter(dayJs(dateToCompare));

export const transformDateObjectToString = ({ year, month, day }: DateObject): string => {
  const monthNum = parseInt(month, 10);
  return `${year}-${(monthNum + 1).toString().padStart(2, '0')}-${day.padStart(2, '0')}`;
};

export const transformTimeObjectToString = ({ hours, minutes }: { hours: string; minutes: string }) =>
  `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
